import { LocationState, UserData } from "@/types";
import { getRegionConfig } from "@/helpers/helpers";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../zustand/Zustand";

const ProtectedIsConfiguredRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { userData } = useAuth() as { userData: UserData | null };
  const location = useLocation();

  // Parent guard handles unauthenticated/unhydrated/no-access cases
  if (!userData) return null;

  if (!userData.region) {
    return (
      <Navigate
        to="/settings/realm"
        state={{ from: location } as LocationState}
        replace
      />
    );
  }

  const config = getRegionConfig(userData);

  if (config.buyingRealms.length === 0 || config.sellingRealms.length === 0) {
    return (
      <Navigate
        to="/settings/realm"
        state={{ from: location } as LocationState}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedIsConfiguredRoute;
